import NetworkService from '../services/network.service'
import {
  CUSTOMER_TYPE, PATTERN
} from '../common/constants'

class CustomerApi {
  getCustomers = async (query: string) => {
    if (query.length > 0) {
      let url = `api/customers`;
      let config = {
        params: {
          query: query
        }
      }
      let data = await NetworkService.get(url, config)
      return data
    }
    else {
      return []
    }
  };

  deleteCustomer = async (id: any) => {
    try {
      let url = `api/customers/delete`;
      let body = { id: id };
      let data = await NetworkService.delete(url, body)
      return data && data.data
        ? data.data : data
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }

  getServiceAdd = async (query: any) => {
    if (query.length > 0) {
      let url = `api/customers/serviceaddress`;
      let config = {
        params: {
          query: query
        }
      }
      let data = await NetworkService.post(url, config)
      return data
    }
    else {
      return []
    }
  }

  getBillingAdd = async (query: any) => {
    if (query.length > 0) {
      let url = `api/customers/billingaddress`;
      let config = {
        params: {
          query: query
        }
      }
      let data = await NetworkService.post(url, config)
      return data
    }
    else {
      return []
    }
  }

  getCustomerDetails = async (id: any, customerType: number) => {
    try {
      let url: any;
      return await Promise.all(id.map(async (record: any) => {
        if (customerType === CUSTOMER_TYPE.BILLING) {
          url = `api/customers/${record.id}`;
        }
        if (customerType === CUSTOMER_TYPE.SERVICE) {
          url = `api/customers/${record.customerId}`;
        }
        let config = {}
        let data = await NetworkService.get(url, config)
        return data
      }))
    } catch (e) {
      console.log(e)
    }
  };

  getAddressDetails = async (id: any) => {
    try {
      return await Promise.all(id.map(async (record: any) => {
        let url = `api/customers/address/${record.id}`;
        let config = {}
        let data = await NetworkService.get(url, config)
        return data
      }))
    } catch (e) {
      console.log(e)
    }
  };

  customerUniqueId = (pattern: string, body: any, id: any) => {
    let customerUID = '';
    switch (pattern) {
      case PATTERN[0]:
        if (body.firstname && body.lastname) {
          customerUID = body.firstname + ", " + body.lastname + " " + id;
        } else {
          customerUID = body.name + " " + id;
        }
        break;

      case PATTERN[1]:
        if (body.firstname && body.lastname) {
          customerUID = body.lastname + ", " + body.firstname + " " + id;
        } else {
          customerUID = body.name + " " + id;
        }
        break;

      case PATTERN[2]:
        if (body.name) {
          customerUID = body.name + " " + id;
        } else {
          customerUID = body.firstname + ", " + body.lastname + " " + id;
        }
        break;

      case PATTERN[3]:
        if (body.response && body.response[0] && body.response[0].billingAddress) {
          customerUID = body.response[0].billingAddress.addressLine1 + " " + id;
        } else {
          customerUID = body.response[0].addressLine1 + " " + id;
        }
        break;

      case PATTERN[4]:
        if (body.response && body.response[0] && body.response[0].name) {
          customerUID = body.response[0].name + " " + id;
        } else {
          customerUID = body.firstname + ", " + body.lastname + " " + id;
        }
        break;

      default:
        if (body.firstname && body.lastname) {
          customerUID = body.lastname + ", " + body.firstname + " " + id;
        } else {
          customerUID = body.name + " " + id;
        }
        break;
    }
    return customerUID;
  }

  saveCustomerDetails = async (state: any) => {
    let url;
    let body: any;
    let type: any;
    if (state.name) {
      type = CUSTOMER_TYPE.COMMERCIAL
    }
    let obj: {
      id: any;
      customerId: any;
      firstname: any;
      lastname: any;
      name: any;
      displayName: any;
      readyForSync: any;
      rootParentId: any;
      customerIdentifier: any;
      customerUniqueId: any;
    }[] = []
    let customerSettings: any = await NetworkService.get('api/customers/settings', {})
    if (state.customerType === 0) {
      let arr = state.response[0].customerIdentifier.split(" ");
      let id = arr.pop();
      url = `api/customers/${state.response[0].id}`;
      let customerUID: any;
      if (customerSettings && customerSettings.parentIDPattern && customerSettings.parentIDPattern !== PATTERN[4]) {
        customerUID = this.customerUniqueId(customerSettings.parentIDPattern, state, id);
      } else {
        customerUID = this.customerUniqueId(PATTERN[1], state, id);
      }

      body = {
        "customerIdentifier": customerUID,
        "customerUniqueId": customerUID,
        "firstname": state.firstname,
        "lastname": state.lastname,
        "name": state.name,
        "rootParentId": state.response[0].rootParentId,
        "displayName": type === CUSTOMER_TYPE.COMMERCIAL ?
          state.name :
          (state.firstname + " " + state.lastname),
        "readyForSync": state.readyForSync,
        "service_addresses": [{}]
      }
      body.customerId = state.id;
      if (state.response[0].service_addresses.length > 0) {
        state.response[0].service_addresses.forEach((serviceAddress: any) => {
          if (serviceAddress.rootParentId === '') {
            obj.push({
              "id": serviceAddress.id,
              "customerId": serviceAddress.customerId,
              "firstname": state.firstname,
              "lastname": state.lastname,
              "name": state.name,
              "displayName": type === CUSTOMER_TYPE.COMMERCIAL ?
                state.name :
                (state.firstname + " " + state.lastname),
              "rootParentId": serviceAddress.rootParentId,
              "customerIdentifier": customerUID,
              "customerUniqueId": customerUID,
              "readyForSync": state.readyForSync
            })
          }
          else {
            obj.push({
              "id": serviceAddress.id,
              "customerId": serviceAddress.customerId,
              "firstname": serviceAddress.firstname,
              "lastname": serviceAddress.lastname,
              "name": serviceAddress.name,
              "displayName": type === CUSTOMER_TYPE.COMMERCIAL ?
                serviceAddress.name :
                (serviceAddress.firstname + " " + serviceAddress.lastname),
              "rootParentId": serviceAddress.rootParentId,
              "customerIdentifier": serviceAddress.customerIdentifier,
              "customerUniqueId": (customerUID + " : " + serviceAddress.customerIdentifier),
              "readyForSync": state.readyForSync
            })
          }
        })
      }
    }
    else {
      let arr3 = state.response[0].customerUniqueId.split(":");
      let parentCustomerId = arr3[0];
      let arr = state.response[0].customerIdentifier.split(" ");
      let id = arr.pop();
      url = `api/customers/${state.response[0].customerId}`;
      let customerUID;
      if (customerSettings && customerSettings.childIDPattern && customerSettings.childIDPattern !== PATTERN[2]) {
        customerUID = this.customerUniqueId(customerSettings.childIDPattern, state, id);
      } else {
        customerUID = this.customerUniqueId(PATTERN[1], state, id);
      }
      body = {
        "customerIdentifier": customerUID,
        "customerUniqueId": (parentCustomerId + ": " + customerUID),
        "firstname": state.firstname,
        "lastname": state.lastname,
        "name": state.name,
        "displayName": type === CUSTOMER_TYPE.COMMERCIAL ?
          state.name :
          (state.firstname + " " + state.lastname),
        "rootParentId": state.response[0].rootParentId,
        "customerId": state.response[0].customerId,
        "readyForSync": state.readyForSync
      }
    }
    body.service_addresses = obj;
    body.companyId = state.companyId;
    let data = await NetworkService.put(url, body);
    return data && data.data
      ? data.data : data

  };

  mergeCustomer = async (params: any) => {
    try {
      let url = `api/customers/merge`;
      let response = await NetworkService.put(url, params);
      return response && response.data
        ? response.data : response
    } catch (e) {
      console.log(e)
    }
  };
}
export default CustomerApi;